var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercurio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 267,
    viewBox: "0 0 213 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6514 180C140.357 180 180.651 139.706 180.651 90C180.651 40.2944 140.357 0 90.6514 0C40.9457 0 0.651367 40.2944 0.651367 90C0.651367 139.706 40.9457 180 90.6514 180Z",
    fill: "#C461C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6514 180C140.357 180 180.651 139.706 180.651 90C180.651 40.2944 140.357 0 90.6514 0C40.9457 0 0.651367 40.2944 0.651367 90C0.651367 139.706 40.9457 180 90.6514 180Z",
    fill: "url(#paint0_radial_1023_10397)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1023_10397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 180
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6514 180C140.357 180 180.651 139.706 180.651 90C180.651 40.2944 140.357 0 90.6514 0C40.9457 0 0.651367 40.2944 0.651367 90C0.651367 139.706 40.9457 180 90.6514 180Z",
    fill: "url(#paint1_radial_1023_10397)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1023_10397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5416 47.5905C44.7979 40.1246 50.6369 30.6125 59.8994 26.141C70.3497 21.1005 83.6845 23.3163 92.6675 15.8105C102.1 7.93539 102.709 -7.41562 111.572 -15.9794C118.549 -22.7167 129.029 -23.7248 137.004 -29.1346C143.931 -33.8357 148.412 -41.4613 153.383 -48.3383C158.353 -55.2153 164.662 -61.9426 172.836 -63.33C181.001 -64.7174 190.632 -57.9302 189.435 -49.4063C188.097 -39.8543 176.599 -35.9318 171.159 -29.3542C164.172 -20.9101 155.359 -14.103 145.538 -9.64141C141.825 -7.9546 137.922 -6.56722 134.718 -3.99208C130.257 -0.398872 127.651 5.06081 124.687 10.0614C118.908 19.783 110.823 28.5864 100.403 32.2095C93.1765 34.7248 85.2316 34.625 78.1948 37.6692C63.5325 44.0172 57.1745 60.9353 44.7879 70.3275C30.8842 80.8577 18.7172 98.4544 20.2543 117.389C28.5087 117.239 35.8947 111.809 41.3245 105.341C46.7143 98.9135 50.2576 88.9923 56.3661 83.5326C59.6598 80.5882 65.0996 79.2307 68.9124 76.975C73.1843 74.4597 77.2366 71.5153 80.6801 67.8622C85.0818 63.181 88.6451 57.2522 94.3942 54.5972C100.263 51.8824 107.18 53.1999 113.299 51.1538C120.066 48.8781 124.927 42.8594 130.636 38.4577C137.543 33.1378 146.037 30.0736 154.63 29.8141C158.393 29.6943 162.416 30.0436 165.66 28.0574C172.746 23.7256 171.229 11.9977 176.918 5.82937C181.11 1.27796 187.898 1.03841 193.527 -1.29717C200.993 -4.41129 205.644 -11.2384 207.64 -19.1035C209.956 -28.2463 213.389 -37.1195 215.346 -46.5217C214.996 -44.8549 218.6 -38.5668 219.039 -36.4108C219.777 -32.8176 219.518 -29.3442 219.847 -25.741C220.486 -18.5546 221.514 -11.6376 220.137 -4.38135C218.879 2.24613 215.555 8.75385 209.976 12.2173C205.904 14.7425 200.903 15.5111 197.17 18.5553C192.719 22.1885 190.902 28.3768 186.79 32.4191C178.495 40.5837 164.552 37.24 154.561 42.9792C147.694 46.9217 143.521 54.707 136.794 58.9091C131.534 62.1929 125.246 62.9714 119.257 64.3488C113.269 65.7262 107 68.0618 103.487 73.2919C101.092 76.8552 100.263 81.3567 97.8178 84.8801C93.6956 90.7989 86.1398 92.5655 79.4125 94.6716C66.996 98.5642 60.4783 110.691 52.8527 120.902C50.6968 123.787 48.5508 126.831 47.7224 130.384C46.9039 133.937 47.7424 138.159 50.6269 140.255C61.5263 126.571 72.9248 109.284 90.8909 105.292C97.9376 103.724 105.513 102.587 111.003 97.8855C117.081 92.6753 119.577 83.8819 126.364 79.6499C132.452 75.8571 140.457 76.7354 146.855 73.5215C152.115 70.8765 155.669 65.8161 160.12 61.9633C172.577 51.2136 190.912 50.7645 205.245 42.6897C214.268 37.6093 221.235 29.7342 227.263 21.4598C230.148 17.4874 233.272 13.4051 235.867 9.27287C236.636 8.05517 242.485 -5.3595 241.187 -5.85856C249.561 -2.63465 254.123 7.66589 252.915 16.8685C250.26 37.27 228.78 42.6199 217.472 57.1225C215.016 60.2765 212.791 63.6901 209.637 66.1454C205.235 69.5789 199.516 70.7467 193.996 71.5852C183.576 73.1821 172.197 74.34 164.562 81.6162C160.22 85.7584 157.555 91.5275 152.764 95.1507C145.218 100.84 134.169 99.9117 126.613 105.591C121.403 109.504 118.638 116.001 113.478 119.984C107.15 124.855 98.7959 125.134 91.5396 127.869C84.5029 130.524 79.7818 136.842 76.8075 143.659C75.2105 147.322 74.4319 151.654 75.969 155.347C79.0133 162.713 89.1142 163.452 96.2008 160.318C100.463 158.431 104.226 155.656 107.729 152.622C111.801 149.099 113.408 147.412 118.668 146.254C127.532 144.318 136.694 141.104 142.773 134.027C146.137 130.115 148.292 125.304 151.536 121.291C158.803 112.288 170.471 108.356 181.33 104.363C188.127 101.858 195.054 99.0333 200.145 93.8731C205.375 88.5631 208.259 81.177 213.958 76.3761C219.977 71.3057 227.952 69.9283 235.118 67.2234C242.894 64.2889 247.954 59.0688 252.546 52.2118C256.468 46.3528 263.145 34.625 270.452 42.0509C277.169 48.888 277.718 61.8835 273.157 69.8884C268.156 78.6418 258.904 83.7721 249.681 87.1657C240.458 90.5593 230.727 92.7153 222.143 97.606C211.783 103.515 203.468 113.236 192.349 117.399C184.794 120.223 176.11 120.423 169.722 125.483C164.592 129.546 161.907 136.033 158.074 141.423C152.475 149.278 144.11 154.938 134.948 157.084C129.638 158.331 123.938 158.481 119.177 161.216C113.788 164.31 110.514 170.139 106.641 175.11C98.9357 184.991 94.4342 183.015 84.6127 179.911C73.8331 176.507 63.3728 174.441 53.0324 169.39C32.2816 159.26 13.1876 143.539 3.30629 122.02C-3.82024 106.509 -5.38728 87.7446 0.262044 71.4654C1.62946 67.5129 3.39612 63.5104 5.75167 60.0769C9.18519 55.0763 9.04545 56.4338 14.1159 57.0526C23.2087 58.1705 31.1237 54.218 37.5816 47.5805L37.5416 47.5905Z",
    fill: "url(#paint2_linear_1023_10397)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9044 158.56C73.7533 161.435 77.2766 166.256 75.7595 169.33C74.2524 172.404 68.2836 172.574 62.4347 169.699C56.5857 166.825 53.0624 162.004 54.5795 158.93C56.0867 155.856 62.0554 155.686 67.9044 158.56Z",
    fill: "url(#paint3_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7193 158.65C57.1148 156.854 61.6562 158.091 66.7366 160.596C71.817 163.092 75.8295 166.046 75.8794 169.041C77.0571 165.956 73.5737 161.335 67.8944 158.55C62.2152 155.766 56.4361 155.835 54.7094 158.65H54.7193Z",
    fill: "#CCCCCC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.19 105.371C110.973 110.122 110.414 116.859 105.952 120.422C101.481 123.986 94.7935 123.027 91.0007 118.276C87.2178 113.525 87.7768 106.788 92.2383 103.225C96.7099 99.6615 103.397 100.62 107.19 105.371Z",
    fill: "url(#paint4_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6475 102.915C96.9194 101.139 100.762 103.574 104.046 107.706C107.33 111.829 109.027 116.33 106.332 120.093C110.434 116.46 110.853 109.982 107.18 105.371C103.507 100.769 97.0991 99.7215 92.6475 102.915Z",
    fill: "#CCCCCC"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3923 119.504C62.0255 121.44 63.2731 126.191 61.187 130.124C59.091 134.056 54.4498 135.683 50.8166 133.747C47.1835 131.811 45.9358 127.06 48.0219 123.127C50.1179 119.194 54.7592 117.568 58.3923 119.504Z",
    fill: "url(#paint5_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2115 122.788C50.597 120.133 53.7211 120.482 56.8752 122.159C60.0292 123.836 62.2251 126.311 61.3567 129.774C63.1932 125.912 61.9057 121.38 58.3823 119.504C54.859 117.627 50.3874 119.105 48.2115 122.778V122.788Z",
    fill: "#CCCCCC"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.611 114.543C158.054 113.825 161.318 115.452 161.887 118.177C162.456 120.901 160.12 123.696 156.667 124.415C153.223 125.133 149.959 123.507 149.39 120.782C148.821 118.057 151.157 115.262 154.611 114.543Z",
    fill: "url(#paint6_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.35 120.542C149.63 118.267 151.926 117.059 154.92 116.43C157.914 115.801 160.659 115.971 161.817 117.937C161.108 115.362 157.944 113.845 154.601 114.544C151.257 115.242 148.961 117.887 149.34 120.532L149.35 120.542Z",
    fill: "#CCCCCC"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9636 98.5933C27.5306 106.438 25.4046 113.475 21.2126 114.314C17.0205 115.152 12.3393 109.473 10.7723 101.628C9.20524 93.7824 11.3312 86.7457 15.5233 85.9073C19.7154 85.0689 24.3965 90.7481 25.9636 98.5933Z",
    fill: "url(#paint7_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9126 85.8474C19.5058 86.8356 21.7017 92.1755 23.0691 98.9926C24.4365 105.81 24.5263 111.928 21.5919 114.224C25.5344 113.056 27.4907 106.199 25.9736 98.5933C24.4465 90.9877 20.0049 85.4182 15.9126 85.8474Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.002 12.0773C126.005 15.5308 126.993 20.9605 124.198 24.1944C121.403 27.4383 115.894 27.2586 111.891 23.8151C107.889 20.3616 106.901 14.9319 109.695 11.698C112.49 8.45411 118 8.63378 122.002 12.0773Z",
    fill: "url(#paint8_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.955 11.4084C112.969 9.61177 116.532 11.2187 120.006 14.2131C123.489 17.2174 125.775 20.6509 124.437 23.8948C126.923 20.631 125.885 15.4208 122.002 12.0771C118.119 8.73343 112.819 8.46394 109.955 11.4084Z",
    fill: "#CCCCCC"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5601 18.4848C61.2569 21.8884 57.7635 27.0586 51.7548 30.053C45.7562 33.0373 39.5179 32.708 37.8311 29.3044C36.1343 25.9008 39.6277 20.7306 45.6364 17.7462C51.635 14.7619 57.8733 15.0912 59.5701 18.4948L59.5601 18.4848Z",
    fill: "url(#paint9_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1754 17.4867C51.1959 15.8698 53.9507 17.5067 55.418 20.4611C56.8852 23.4155 56.6057 26.7392 52.2939 29.7835C57.9632 26.7592 61.197 21.7886 59.5601 18.4948C57.9232 15.201 52.0044 14.7818 46.1754 17.4867Z",
    fill: "#CCCCCC"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6834 62.7813C76.0589 67.5623 72.9748 73.9403 66.7765 77.0244C60.5882 80.1086 53.6313 78.7312 51.2558 73.9503C48.8803 69.1693 51.9645 62.7913 58.1628 59.7072C64.3511 56.623 71.3079 58.0004 73.6834 62.7813Z",
    fill: "url(#paint10_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7217 59.4375C64.0416 58.0402 67.3254 60.6253 69.4015 64.7774C71.4776 68.9296 71.6573 73.3213 67.3354 76.7249C73.1544 73.5509 75.999 67.4125 73.6834 62.7712C71.3778 58.13 64.7703 56.7027 58.7217 59.4275V59.4375Z",
    fill: "#CCCCCC"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.18 70.1174C148.173 72.3233 148.951 78.5615 145.917 84.0511C142.883 89.5407 137.193 92.2057 133.201 90.0099C129.209 87.804 128.43 81.5658 131.464 76.0762C134.499 70.5865 140.188 67.9216 144.18 70.1174Z",
    fill: "url(#paint11_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M131.744 75.5871C134.938 71.7743 138.551 71.914 142.014 73.8304C145.478 75.7468 147.694 78.8209 146.177 83.562C148.891 78.1921 148.043 72.2633 144.18 70.1274C140.308 67.9914 134.838 70.4368 131.744 75.597V75.5871Z",
    fill: "#CCCCCC"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.933 141.353C135.018 138.189 143.162 139.686 145.128 144.707C147.095 149.727 142.144 156.365 134.059 159.539C125.975 162.703 117.83 161.206 115.864 156.185C113.897 151.165 118.848 144.527 126.933 141.353Z",
    fill: "url(#paint12_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.714 155.716C115.874 151.145 121.094 147.601 128.111 144.846C135.127 142.092 141.715 141.014 144.939 144.258C142.673 139.596 134.778 138.269 126.933 141.343C119.098 144.417 114.197 150.755 115.704 155.716H115.714Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8054 39.525C96.7299 40.9722 98.2271 43.9167 97.1391 46.1225C96.0512 48.3184 92.8073 48.9372 89.8828 47.4899C86.9583 46.0427 85.4612 43.0982 86.5491 40.8924C87.6371 38.6965 90.8809 38.0777 93.8154 39.525H93.8054Z",
    fill: "url(#paint13_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6489 40.7029C88.1062 39.2955 90.4617 39.7447 92.9969 41.0023C95.5421 42.2599 97.4585 43.9068 97.2289 45.923C98.1272 43.7471 96.6401 40.9325 93.8054 39.5251C90.9708 38.1278 87.8267 38.6568 86.6489 40.7029Z",
    fill: "#CCCCCC"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M161.787 44.356C163.703 47.001 163.164 50.6541 160.599 52.5106C158.024 54.377 154.391 53.7482 152.475 51.1032C150.558 48.4582 151.097 44.8051 153.662 42.9486C156.237 41.0821 159.871 41.7109 161.787 44.356Z",
    fill: "url(#paint14_linear_1023_10397)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.892 42.7789C156.297 41.8806 158.313 43.268 159.98 45.5637C161.647 47.8593 162.416 50.3247 160.819 52.3309C163.194 50.4245 163.643 46.9111 161.787 44.346C159.93 41.7808 156.457 41.1121 153.902 42.7789H153.892Z",
    fill: "#CCCCCC"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_10397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.172 239.867C184.687 234.572 162.973 207.551 162.973 207.551L161.088 208.98C161.088 208.98 187.815 241.608 194.925 242.678L194.172 239.867Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.994 250.892C173.285 238.9 155.434 213.269 155.434 213.269L157.319 211.84C157.319 211.84 181.069 245.009 181.513 252.363L178.994 250.892Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.786 212.244L160.905 209.119C160.905 209.119 184.298 240.918 192.23 242.092C200.161 243.266 185.086 244.58 185.086 244.58L181.599 251.622C181.599 251.622 173.167 232.876 169.145 227.234C162.315 217.671 156.794 212.238 156.794 212.238L156.786 212.244Z",
    fill: "#C80923",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.557 208.625C161.557 208.625 183.743 237.857 195.019 242.669L194.75 245.078C194.75 245.078 187.152 242.975 159.985 209.805L161.551 208.617L161.557 208.625Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.699 212.31C156.699 212.31 178.925 241.349 180.985 252.15L182.881 253.167C182.881 253.167 175.486 233.084 158.265 211.122L156.699 212.31Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M169.926 220.415C168.936 218.084 168.449 216.049 168.246 214.337C164.976 210.403 162.792 207.676 162.792 207.676L155.253 213.394C155.253 213.394 167.348 229.962 174.678 242.415C175.878 240.403 178.083 238.768 178.365 235.372C178.794 230.361 173.288 228.35 169.912 220.413L169.926 220.415Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.877 207.648L172.212 209.073C172.64 210.915 172.037 212.838 170.631 214.105C168.282 216.225 164.402 219.532 160.446 221.981C158.81 222.997 156.743 223.037 155.068 222.077L153.811 221.353L171.877 207.648Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M169.25 212.56C166.9 214.68 163.021 217.987 159.065 220.437C157.656 221.305 155.943 221.464 154.431 220.882L153.684 221.449L154.941 222.174C156.616 223.133 158.683 223.093 160.319 222.078C164.283 219.622 168.155 216.322 170.504 214.202C171.91 212.935 172.513 211.012 172.085 209.169L171.75 207.745L170.955 208.348C171.063 209.92 170.445 211.478 169.258 212.554L169.25 212.56Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.132 203.033L172.424 205.142C172.644 206.728 172.056 208.326 170.857 209.387C167.848 212.057 161.759 217.24 155.906 220.84C154.529 221.685 152.81 221.786 151.347 221.104L149.455 220.222L172.134 203.019L172.132 203.033Z",
    fill: "#00FF9F",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.311 177.216L165.534 178.65C169.125 179.208 172.38 181.035 174.723 183.806C179.058 188.936 186.105 197.682 190.009 204.73C191.035 206.583 189.246 208.729 187.225 208.057L172.12 203.018L156.311 177.216Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M172.041 202.914L187.146 207.954C189.167 208.626 190.956 206.48 189.93 204.627C189.127 203.182 188.192 201.662 187.18 200.124C187.024 201.482 185.635 202.574 184.114 202.062L169.008 197.022L172.041 202.914Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.673 212.821C167.001 208.779 172.109 203.201 172.109 203.201C172.109 203.201 146.66 158.568 137.095 151.443C127.522 144.323 109.803 144.937 109.803 144.937C109.803 144.937 104.492 161.806 108.84 172.888C113.189 183.971 149.068 220.34 149.068 220.34C149.068 220.34 156.352 216.87 161.671 212.834L161.673 212.821Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.876 146.341C117.42 148.429 123.581 151.873 128.69 156.553C133.684 161.346 137.424 167.178 141.567 172.666C149.527 183.84 157.29 195.15 164.694 206.696C156.646 195.589 148.833 184.329 140.794 173.215C136.756 167.734 132.986 161.913 128.19 157.083C123.273 152.357 117.259 148.777 110.89 146.343L110.876 146.341Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.063 189.088C139.553 184.529 145.352 179.115 151.391 173.983C146.14 179.883 140.148 185.455 133.063 189.088Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.07 171.147C138.07 171.147 140.442 172.755 135.034 182.445C129.626 192.134 137.203 193.815 137.203 193.815C137.203 193.815 135.263 185.44 137.027 184.002C137.027 184.002 139.113 190.199 142.136 193.843C145.159 197.488 160.465 213.737 160.465 213.737L149.139 220.45C149.139 220.45 147.672 216.113 143.921 211.994C133.104 200.106 111.207 176.693 110.329 172.436C109.157 166.711 107.103 152.861 109.78 146.37C109.78 146.37 115.18 166.801 119.508 171.348C123.836 175.894 138.07 171.147 138.07 171.147Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 149.097C109.653 149.097 108.978 161.397 114.517 170.586C120.057 179.775 131.708 193.084 131.708 193.084C131.708 193.084 116.412 173.821 115.083 169.831C113.755 165.84 109.985 155.81 109.653 149.097Z",
    fill: "#A6A5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.622 179.833C165.975 179.919 172.33 181.725 175.018 186.739C171.434 182.492 165.82 181.063 160.622 179.833Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 203.308C175.327 204.092 172.356 203.327 171.773 202.466L166.632 193.864L156.303 177.222C156.303 177.222 167.611 192.958 172.981 198.03C174.29 199.266 175.184 200.88 175.544 202.649L175.675 203.314L175.683 203.308Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.346 145.914C112.346 145.914 129.406 147.692 136.902 155.021C144.399 162.35 159.426 184.498 159.426 184.498C159.426 184.498 150.52 166.776 140.221 156.438C129.921 146.099 123.317 147.351 112.354 145.908L112.346 145.914Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M136.444 178.932C140.687 175.714 141.505 169.675 138.272 165.444C135.039 161.213 128.98 160.392 124.737 163.61C120.495 166.828 119.677 172.867 122.909 177.098C126.142 181.329 132.202 182.15 136.444 178.932Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.423 206.808C146.2 206.218 146.35 205.112 145.758 204.337C145.165 203.562 144.055 203.411 143.278 204.001C142.501 204.59 142.351 205.697 142.943 206.472C143.535 207.247 144.646 207.398 145.423 206.808Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.518 203.144C141.904 202.851 141.979 202.3 141.684 201.915C141.39 201.53 140.838 201.455 140.451 201.748C140.065 202.041 139.99 202.591 140.285 202.977C140.579 203.362 141.131 203.437 141.518 203.144Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.063 205.093C139.34 204.883 139.393 204.49 139.182 204.214C138.972 203.938 138.576 203.884 138.3 204.094C138.023 204.304 137.97 204.698 138.18 204.974C138.391 205.25 138.787 205.303 139.063 205.093Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.728 195.575C131.982 195.382 132.031 195.02 131.837 194.766C131.643 194.512 131.279 194.462 131.025 194.656C130.77 194.849 130.721 195.211 130.915 195.465C131.109 195.719 131.473 195.769 131.728 195.575Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.987 193.057C129.303 192.817 129.364 192.367 129.123 192.052C128.882 191.737 128.43 191.675 128.114 191.915C127.798 192.155 127.737 192.605 127.978 192.921C128.219 193.236 128.671 193.297 128.987 193.057Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.061 180.741C150.615 180.322 150.721 179.534 150.3 178.982C149.878 178.43 149.088 178.323 148.534 178.743C147.981 179.163 147.874 179.95 148.296 180.502C148.718 181.054 149.508 181.161 150.061 180.741Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 183.279C152.277 183.069 152.33 182.675 152.12 182.399C151.909 182.123 151.514 182.07 151.237 182.28C150.96 182.49 150.907 182.883 151.118 183.159C151.329 183.435 151.724 183.489 152 183.279Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M133.063 189.088C133.063 189.088 138.53 188.286 140.964 188.857C143.398 189.429 143.081 189.393 147.039 187.832C150.996 186.271 152.801 185.215 152.239 181.52C151.676 177.825 151.391 173.983 151.391 173.983L142.493 182.361L133.063 189.088Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.513 196.682C180.115 196.226 180.231 195.37 179.772 194.77C179.314 194.17 178.454 194.053 177.853 194.51C177.251 194.966 177.135 195.822 177.594 196.422C178.052 197.022 178.911 197.139 179.513 196.682Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.397 193.758C178.608 193.598 178.648 193.298 178.488 193.088C178.327 192.878 178.026 192.837 177.815 192.997C177.604 193.157 177.564 193.457 177.724 193.667C177.885 193.878 178.186 193.918 178.397 193.758Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.376 198.406L127.31 207.646C126.893 211.243 127.795 214.856 129.851 217.844C133.661 223.372 140.248 232.468 146.027 238.093C147.546 239.571 150.099 238.424 149.987 236.305L149.131 220.456L128.376 198.406Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.761 203.243C129.568 208.563 129.448 214.341 132.611 218.907C128.476 214.991 128.419 208.408 129.761 203.243Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.733 223.619C141.335 223.163 141.451 222.306 140.992 221.706C140.534 221.106 139.675 220.99 139.073 221.446C138.471 221.902 138.355 222.759 138.814 223.359C139.272 223.959 140.132 224.075 140.733 223.619Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.21 221.763C138.42 221.603 138.461 221.303 138.3 221.093C138.14 220.882 137.839 220.842 137.628 221.001C137.417 221.161 137.376 221.461 137.537 221.672C137.698 221.882 137.999 221.923 138.21 221.763Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M148.933 220.443L149.789 236.292C149.901 238.411 147.348 239.558 145.829 238.08C144.645 236.924 143.423 235.621 142.205 234.24C143.56 234.452 144.986 233.409 144.895 231.811L144.04 215.962L148.933 220.443Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M121.332 159.893C116.107 163.593 110.718 166.616 107.647 167.956C107.695 168.546 107.752 169.129 107.844 169.71C110.296 168.777 115.317 166.422 120.322 163.076C121.068 162.573 121.822 162.064 122.572 161.532C127.498 158.034 132.101 153.702 134.617 149.827C134.099 149.594 133.572 149.38 133.042 149.18C130.429 152.829 125.939 156.635 121.33 159.907L121.332 159.893Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.18 158.477C116.606 158.154 116.688 157.547 116.363 157.122C116.039 156.698 115.43 156.615 115.004 156.938C114.578 157.261 114.496 157.868 114.821 158.293C115.145 158.718 115.754 158.8 116.18 158.477Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.925 158.144C116.167 157.96 116.213 157.617 116.029 157.376C115.845 157.135 115.5 157.088 115.259 157.271C115.017 157.454 114.971 157.798 115.155 158.039C115.339 158.28 115.684 158.327 115.925 158.144Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.489 161.083C111.915 160.76 111.997 160.154 111.673 159.729C111.348 159.304 110.739 159.222 110.313 159.545C109.887 159.868 109.805 160.474 110.13 160.899C110.455 161.324 111.063 161.406 111.489 161.083Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.235 160.75C111.476 160.567 111.523 160.223 111.339 159.982C111.155 159.741 110.81 159.694 110.568 159.878C110.326 160.061 110.28 160.405 110.464 160.646C110.648 160.887 110.993 160.933 111.235 160.75Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.698 155.25C121.124 154.927 121.206 154.32 120.882 153.895C120.557 153.471 119.948 153.388 119.522 153.711C119.096 154.034 119.014 154.641 119.339 155.066C119.664 155.49 120.272 155.573 120.698 155.25Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.444 154.917C120.685 154.733 120.732 154.39 120.548 154.149C120.364 153.908 120.018 153.861 119.777 154.044C119.535 154.227 119.489 154.571 119.673 154.812C119.857 155.053 120.202 155.1 120.444 154.917Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.038 151.494C125.464 151.171 125.546 150.565 125.222 150.14C124.897 149.715 124.288 149.633 123.863 149.956C123.437 150.279 123.354 150.885 123.679 151.31C124.004 151.735 124.612 151.818 125.038 151.494Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.784 151.161C125.025 150.978 125.072 150.634 124.888 150.393C124.704 150.152 124.359 150.106 124.117 150.289C123.875 150.472 123.829 150.816 124.013 151.057C124.197 151.298 124.542 151.344 124.784 151.161Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.773 202.466C171.773 202.466 162.178 213.202 154.118 216.61",
    stroke: "#3F3D56",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M162.735 216.249L170.483 209.883C170.638 209.741 170.791 209.612 170.93 209.482C172.04 208.502 172.619 207.073 172.531 205.611C169.827 206.46 166.364 208.11 163.951 211.281C162.631 213.021 161.045 216.141 158.993 218.962C160.268 218.083 161.519 217.172 162.721 216.247L162.735 216.249Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.282 226.934C172.282 226.934 168.353 215.546 157.027 200.724C146.617 187.099 142.544 187.045 141.948 187.121C141.904 187.129 141.859 187.151 141.827 187.176C141.827 187.176 141.761 187.238 141.742 187.278C141.504 187.821 140.478 191.756 150.889 205.38C162.214 220.202 172.186 227.006 172.186 227.006L172.289 226.928L172.282 226.934Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.18 208.43C157.729 208.81 158.194 210.7 158.637 212.168C158.795 212.687 158.104 213.048 157.771 212.612C156.91 211.486 156.194 209.611 157.327 206.935C158.441 204.299 156.418 204.957 156.125 204.49L156.009 204.34C156.009 204.34 155.593 203.779 155.5 202.884C155.421 202.156 154.767 201.612 154.031 201.669C152.461 201.783 149.842 201.627 148.095 199.67C146.189 197.521 143.171 190.628 141.669 187.019C141.669 187.019 141.604 187.082 141.584 187.122C141.347 187.665 140.321 191.6 150.731 205.224C162.057 220.046 172.029 226.85 172.029 226.85L172.132 226.771C172.132 226.771 172.077 226.6 171.95 226.271C169.992 224.036 163.335 216.408 161.734 214.428C159.852 212.098 158.194 208.432 158.194 208.432L158.18 208.43Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.348 199.706C154.042 199.18 154.176 198.192 153.647 197.5C153.119 196.808 152.127 196.674 151.434 197.2C150.74 197.727 150.606 198.714 151.135 199.406C151.663 200.098 152.654 200.233 153.348 199.706Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M142.05 187.37C142.05 187.37 141.96 187.4 141.929 187.424C141.897 187.448 141.863 187.486 141.843 187.526C141.716 187.836 141.327 189.234 142.904 192.86C142.924 192.82 142.95 192.788 142.981 192.764C143.021 192.734 143.059 192.717 143.103 192.709C143.692 192.625 147.772 192.688 158.182 206.312C164.254 214.258 168.198 221.212 170.55 225.967C171.653 226.834 172.274 227.253 172.274 227.253L172.377 227.174C172.377 227.174 168.449 215.786 157.123 200.964C146.713 187.34 142.639 187.286 142.044 187.362L142.05 187.37Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.443 198.935C149.707 198.736 149.758 198.36 149.557 198.098C149.356 197.835 148.98 197.784 148.716 197.984C148.453 198.184 148.402 198.559 148.603 198.822C148.804 199.084 149.18 199.135 149.443 198.935Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.261 196.8C150.485 196.63 150.528 196.311 150.357 196.088C150.187 195.864 149.867 195.821 149.643 195.991C149.419 196.161 149.375 196.479 149.546 196.703C149.717 196.926 150.037 196.97 150.261 196.8Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.715 197.498C148.209 203.78 152.954 209.2 157.829 214.446C152.464 209.71 147.58 204.107 144.715 197.498Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M161.587 185.715C161.587 185.715 156.905 182.415 157.518 185.946C158.131 189.477 159.052 188.102 160.712 193.645C162.372 199.187 164.13 197.428 165.766 200.258C167.401 203.089 164.459 203.003 163.813 204.821C163.167 206.639 162.478 208.728 163.907 209.924C165.335 211.12 171.367 201.622 171.367 201.622L161.579 185.721L161.587 185.715Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.369 203.197C164.716 202.934 164.783 202.44 164.518 202.094C164.254 201.748 163.758 201.681 163.411 201.944C163.064 202.208 162.997 202.701 163.262 203.047C163.526 203.393 164.022 203.461 164.369 203.197Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.227 197.958C160.342 197.872 160.364 197.709 160.277 197.595C160.19 197.481 160.026 197.459 159.912 197.546C159.798 197.632 159.776 197.795 159.863 197.909C159.95 198.023 160.113 198.045 160.227 197.958Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.323 177.93L141.663 177.904L141.14 177.499C140.895 177.31 140.53 177.474 140.517 177.784L140.492 178.442L140.086 178.963C139.896 179.208 140.061 179.571 140.373 179.585L141.033 179.61L141.556 180.015C141.801 180.205 142.166 180.041 142.179 179.73L142.204 179.072L142.61 178.552C142.8 178.307 142.636 177.944 142.323 177.93Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.699 181.968C141.011 181.731 141.071 181.288 140.833 180.977C140.596 180.666 140.15 180.605 139.838 180.842C139.527 181.078 139.466 181.522 139.704 181.833C139.942 182.144 140.387 182.204 140.699 181.968Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.236 239.984C181.864 239.508 181.985 238.614 181.506 237.988C181.028 237.361 180.131 237.24 179.503 237.716C178.875 238.192 178.754 239.086 179.232 239.713C179.711 240.339 180.608 240.461 181.236 239.984Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.889 237.718C179.104 237.555 179.146 237.248 178.982 237.034C178.818 236.819 178.51 236.778 178.295 236.941C178.08 237.104 178.038 237.41 178.202 237.625C178.366 237.84 178.674 237.881 178.889 237.718Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.05 231.438C171.621 231.005 171.731 230.192 171.296 229.623C170.861 229.053 170.046 228.943 169.475 229.376C168.904 229.809 168.794 230.622 169.229 231.191C169.664 231.76 170.479 231.871 171.05 231.438Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.624 233.477C170.809 233.337 170.844 233.075 170.704 232.891C170.563 232.707 170.3 232.671 170.115 232.811C169.931 232.951 169.895 233.214 170.036 233.398C170.176 233.581 170.44 233.617 170.624 233.477Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.55 224.455C175.717 224.328 175.749 224.09 175.622 223.924C175.494 223.758 175.256 223.725 175.089 223.852C174.922 223.978 174.89 224.216 175.017 224.382C175.144 224.549 175.383 224.581 175.55 224.455Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.472 225.482C176.578 225.402 176.598 225.252 176.518 225.148C176.438 225.043 176.287 225.022 176.182 225.102C176.077 225.182 176.057 225.332 176.137 225.437C176.217 225.541 176.367 225.562 176.472 225.482Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.733 177.925C138.975 174.707 139.794 168.669 136.561 164.438C133.328 160.207 127.268 159.386 123.026 162.604C118.784 165.822 117.965 171.86 121.198 176.091C124.431 180.322 130.491 181.143 134.733 177.925Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.456 177.547C138.514 174.468 139.297 168.692 136.205 164.645C133.112 160.599 127.316 159.813 123.258 162.891C119.2 165.97 118.418 171.746 121.51 175.792C124.602 179.839 130.398 180.625 134.456 177.547Z",
    stroke: "#04DAF6",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38 164.408C124.665 164.192 124.72 163.786 124.503 163.501C124.285 163.216 123.877 163.161 123.592 163.377C123.306 163.594 123.251 164 123.469 164.285C123.686 164.57 124.094 164.625 124.38 164.408Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.136 177.176C134.421 176.959 134.476 176.553 134.259 176.268C134.041 175.984 133.633 175.928 133.348 176.145C133.062 176.362 133.007 176.768 133.225 177.053C133.442 177.337 133.85 177.393 134.136 177.176Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.659 165.936C135.944 165.72 135.999 165.313 135.782 165.029C135.564 164.744 135.156 164.689 134.871 164.905C134.586 165.122 134.53 165.528 134.748 165.813C134.966 166.098 135.373 166.153 135.659 165.936Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.856 175.648C123.142 175.431 123.197 175.025 122.979 174.74C122.762 174.455 122.354 174.4 122.069 174.617C121.783 174.833 121.728 175.24 121.946 175.524C122.163 175.809 122.571 175.864 122.856 175.648Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.334 162.848C130.62 162.631 130.675 162.225 130.457 161.94C130.24 161.656 129.832 161.6 129.546 161.817C129.261 162.033 129.206 162.44 129.423 162.724C129.641 163.009 130.049 163.064 130.334 162.848Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.181 178.737C128.466 178.52 128.521 178.114 128.304 177.829C128.086 177.545 127.679 177.49 127.393 177.706C127.108 177.923 127.053 178.329 127.27 178.614C127.488 178.898 127.895 178.954 128.181 178.737Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.23 171.872C137.515 171.656 137.571 171.249 137.353 170.965C137.135 170.68 136.728 170.625 136.442 170.841C136.157 171.058 136.102 171.464 136.319 171.749C136.537 172.034 136.945 172.089 137.23 171.872Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.285 169.712C121.571 169.496 121.626 169.089 121.408 168.805C121.191 168.52 120.783 168.465 120.497 168.681C120.212 168.898 120.157 169.304 120.374 169.589C120.592 169.873 121 169.929 121.285 169.712Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.812 175.411C135.662 173.249 136.212 169.192 134.04 166.35C131.868 163.507 127.797 162.955 124.947 165.118C122.097 167.28 121.547 171.337 123.719 174.179C125.891 177.021 129.962 177.573 132.812 175.411Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.226 164.473L126.133 176.106C127.083 176.576 128.136 176.804 129.188 176.783L129.292 163.851C128.256 163.81 127.202 164.008 126.226 164.473Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.871 163.9L129.771 176.741C130.003 176.715 130.237 176.676 130.458 176.62L130.559 164.029C130.331 163.977 130.109 163.933 129.871 163.9Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M133.779 168.802C132.202 174.02 132.341 176.207 128.727 177.182C126.446 177.797 123.983 177.599 122.48 177.374C125.875 180.272 130.948 180.533 134.654 177.722C138.789 174.586 139.684 168.771 136.746 164.548C135.691 165.173 134.511 166.406 133.785 168.81L133.779 168.802Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.073 149.22C131.744 148.599 130.354 148.063 128.931 147.614C127.203 150.842 124.353 153.179 119.171 157.197C114.252 161.017 108.762 163.515 107.139 163.856C107.192 165.307 107.318 166.753 107.546 168.17C110.256 167.179 116.363 164.551 121.696 160.518C127.398 156.193 130.716 152.974 133.071 149.234L133.073 149.22Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M120.474 158.902C115.488 162.421 110.321 165.276 107.386 166.513C107.45 167.091 107.515 167.668 107.615 168.243C109.972 167.383 114.786 165.184 119.576 162.001C120.29 161.522 121.012 161.037 121.73 160.53C126.434 157.2 130.799 153.05 133.147 149.302C132.638 149.062 132.126 148.836 131.605 148.63C129.15 152.158 124.883 155.796 120.48 158.91L120.474 158.902Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1023_10397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-93.4609 264.161) scale(339.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#660570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#771580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A340A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C461C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1023_10397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.239 -81.7755) scale(312.999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EEA9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EBA4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E396EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D57FDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C461C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1023_10397",
    x1: -3.19143,
    y1: 59.468,
    x2: 276.101,
    y2: 59.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C461C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1023_10397",
    x1: 67.016,
    y1: 154.638,
    x2: 63.2332,
    y2: 174.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1023_10397",
    x1: 102.01,
    y1: 96.8568,
    x2: 96.0511,
    y2: 127.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1023_10397",
    x1: 56.8053,
    y1: 115.332,
    x2: 52.3038,
    y2: 138.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1023_10397",
    x1: 157.076,
    y1: 112.068,
    x2: 154.131,
    y2: 127.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1023_10397",
    x1: 22.1408,
    y1: 80.787,
    x2: 14.4453,
    y2: 120.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1023_10397",
    x1: 119.207,
    y1: 6.34809,
    x2: 114.586,
    y2: 30.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1023_10397",
    x1: 51.2158,
    y1: 10.969,
    x2: 46.0656,
    y2: 37.3891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1023_10397",
    x1: 65.439,
    y1: 53.1296,
    x2: 59.3705,
    y2: 84.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1023_10397",
    x1: 141.745,
    y1: 64.4182,
    x2: 135.517,
    y2: 96.3778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1023_10397",
    x1: 133.74,
    y1: 133.837,
    x2: 127.122,
    y2: 167.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1023_10397",
    x1: 93.0868,
    y1: 37.0896,
    x2: 90.5316,
    y2: 50.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1023_10397",
    x1: 158.723,
    y1: 39.5251,
    x2: 155.459,
    y2: 56.2834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#480451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660570"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_10397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.419,
    height: 131.682,
    fill: "white",
    transform: "matrix(0.796714 -0.604357 0.60715 0.794588 86.6514 162.211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercurio);
export default __webpack_public_path__ + "static/media/mercurio.b5f778aa24394c17d65d8c0e9848a7f7.svg";
export { ForwardRef as ReactComponent };